export class CredentialsLogin {
  email: string;
  password: string;
}
